import type { ComponentProps, FC, ReactNode } from 'react'

import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'

type SearchFieldProps = Omit<ComponentProps<'input'>, 'type'> & {
    label: string
    wrapperClassName?: string
}

export const SearchField: FC<SearchFieldProps> = ({ label, wrapperClassName, className, ...props }): ReactNode => {
    return (
        <div className={cn('relative min-w-0', wrapperClassName)}>
            <Search className='pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground' aria-hidden='true' />

            <Input type='search' aria-label={label} className={cn('h-9 pl-9', className)} {...props} />
        </div>
    )
}
